import React, { Fragment } from 'react';
import { Row, Col } from "react-bootstrap";
import moment from "moment";


const ItinerarioComponent = ({ nombreMes, viajeIda, viajeVuelta, t }) => {
    return (
        <>
            <Row className="justify-content-left">
                <Col lg={6} md={12} sm={12} xs={12}>
                    <div className="titulo-mes">{t(`months.${moment(nombreMes).format("MMM")}`)}</div>
                    <div className="disclaimer">⚠️{t("itinerarios.disclaimer")}</div>
                </Col>
            </Row>

            <Row>
                {Object.keys(viajeIda).map((id_viaje, index) => {
                    const vueltaId = Object.keys(viajeVuelta)[index];

                    return (
                        <React.Fragment key={id_viaje}>
                            {/* Tabla de Ida */}
                            <Col lg={6} md={12} sm={12} xs={12}>
                                {!id_viaje.startsWith("k") && (
                                    <div className="table-itinerario">
                                        <div className="thead-itinerario">
                                            <div className="th-itinerario-surnor">{t("itinerarios.sur-norte")}</div>
                                        </div>
                                        <div className="overflow-x-auto">
                                            <div className="tbody-itinerario">
                                                {viajeIda[id_viaje].map(({ id, origen, destino, zarpeOriginal, horaLlegada }, idx) => (
                                                    <React.Fragment key={id}>
                                                        {/* Fila de salida */}
                                                        <div className="fila">
                                                            <div className="Columna fecha-mes">{t(`days.${moment(zarpeOriginal).format("ddd")}`)}</div>
                                                            <div className="Columna fecha-dia">{moment(zarpeOriginal).format("DD")}</div>
                                                            <div className="Columna embarque">({idx === 0 ? t(`itinerarios.zarpe`) : t(`itinerarios.salida`)})</div>
                                                            <div className="Columna"><div className="route-container"><div className="route" /><div className="icon" /></div></div>
                                                            <div className="Columna hora">{moment(zarpeOriginal).format("HH:mm")}</div>
                                                            <div className="Columna lugar">{origen}</div>
                                                        </div>
                                                        {/* Fila de llegada */}
                                                        <div className="fila">
                                                            <div className="Columna fecha-mes">{zarpeOriginal === horaLlegada ? "s/ info" : t(`days.${moment(horaLlegada).format("ddd")}`)}</div>
                                                            <div className="Columna fecha-dia">{zarpeOriginal === horaLlegada ? "s/ info" : moment(horaLlegada).format("DD")}</div>
                                                            <div className="Columna embarque">({t(`itinerarios.llegada`)})</div>
                                                            <div className="Columna"><div className="route-container"><div className="route" /><div className="icon" /></div></div>
                                                            <div className="Columna hora">{zarpeOriginal === horaLlegada ? "s/ info" : moment(horaLlegada).format("HH:mm")}*</div>
                                                            <div className="Columna lugar">{destino}</div>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Col>

                            {/* Tabla de Vuelta */}
                            {vueltaId && (
                                <Col lg={6} md={12} sm={12} xs={12}>
                                    <div className="table-itinerario">
                                        <div className="thead-itinerario">
                                            <div className="th-itinerario-norsur">{t("itinerarios.norte-sur")}</div>
                                        </div>
                                        <div className="overflow-x-auto">
                                            <div className="tbody-itinerario">
                                                {viajeVuelta[vueltaId].map(({ id, origen, destino, zarpeOriginal, horaLlegada }, idx) => (
                                                    <React.Fragment key={id}>
                                                        <div className="fila">
                                                            <div className="Columna fecha-mes">{t(`days.${moment(zarpeOriginal).format("ddd")}`)}</div>
                                                            <div className="Columna fecha-dia">{moment(zarpeOriginal).format("DD")}</div>
                                                            <div className="Columna embarque">({idx === 0 ? t(`itinerarios.zarpe`) : t(`itinerarios.salida`)})</div>
                                                            <div className="Columna"><div className="route-container"><div className="route" /><div className="icon" /></div></div>
                                                            <div className="Columna hora">{moment(zarpeOriginal).format("HH:mm")}</div>
                                                            <div className="Columna lugar">{origen}</div>
                                                        </div>
                                                        <div className="fila">
                                                            <div className="Columna fecha-mes">{zarpeOriginal === horaLlegada ? "s/ info" : t(`days.${moment(horaLlegada).format("ddd")}`)}</div>
                                                            <div className="Columna fecha-dia">{zarpeOriginal === horaLlegada ? "s/ info" : moment(horaLlegada).format("DD")}</div>
                                                            <div className="Columna embarque">({t(`itinerarios.llegada`)})</div>
                                                            <div className="Columna"><div className="route-container"><div className="route" /><div className="icon" /></div></div>
                                                            <div className="Columna hora">{zarpeOriginal === horaLlegada ? "s/ info" : moment(horaLlegada).format("HH:mm")}*</div>
                                                            <div className="Columna lugar">{destino}</div>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            )}
                        </React.Fragment>
                    );
                })}
            </Row>
        </>
    );
};

export default ItinerarioComponent;
